import alEkhbariya from "@/assets/outlets/al-ekhbariya.png";
import saudiSports from "@/assets/outlets/saudi-sports.png";
import dawriPlus from "@/assets/outlets/dawri-plus.png";
import art from "@/assets/outlets/art.png";
import mbcPro from "@/assets/outlets/mbc-pro.png";
import beinSports from "@/assets/outlets/bein-sports.png";
import ssc from "@/assets/outlets/ssc.png";

// Each outlet has a transparent logo image + a display name.
// Add more entries here as new logos arrive.
export const outlets = [
  { id: "mbc-pro", name: "MBC PRO Sports", image: mbcPro },
  { id: "ssc", name: "SSC", image: ssc },
  { id: "bein-sports", name: "beIN Sports", image: beinSports },
  { id: "al-ekhbariya", name: "قناة الإخبارية", image: alEkhbariya },
  { id: "saudi-sports", name: "القنوات الرياضية السعودية", image: saudiSports },
  { id: "dawri-plus", name: "دوري بلس", image: dawriPlus },
  { id: "art", name: "ART", image: art },
];
